import React from 'react';
import Navigation from '../../components/navigation'
import {Link} from 'react-router-dom'
import './detail.css'
export default class venue extends React.Component {
    render(){
        return (
            <main>
                <Navigation tab="equipment"></Navigation>
                <div className="detail_title"><Link to="/equipment">器材</Link> / {this.props.match.params.id == 1 ? '击剑面罩' : ''}{this.props.match.params.id == 2 ? '剑' : ''}{this.props.match.params.id == 3 ? '击剑服' : ''}</div>
                {this.props.match.params.id == 1 &&
                <div className="equipment_pic">
                    <img src={require('./../../pic/equipment01.jpg')} alt=""></img>
                    <p>击剑面罩</p>
                    <p>护面由金属保护网和护颈组成，考虑到舒适度，内部垫有海绵，面罩后部装有固定的安全装置。护面的作用是保护学员头部，在护面头部四周都有海绵衬垫，这也是最吸汗的地方，特别是下巴处，满头的汗流下来全部积在下巴处的海绵垫内，每次使用后不经清洗晾晒就放置在剑包内，容易滋生大量细菌，孩子下次使用时容易将这些细菌吸入口腔和肺部，并且细菌对皮肤也非常不好。</p>
                </div>
                }
                {this.props.match.params.id == 2 &&
                <div className="equipment_pic">
                    <img src={require('./../../pic/equipment02.jpg')} alt=""></img>
                    <p>剑</p>
                    <p>剑最易坏的是剑尖，一把剑好用与否最重要看剑尖的灵敏度，剑尖是整支剑里最“娇气”部分，所以不能刺硬的地方，如地板，墙壁等；在剑包内放置时应该将剑柄朝下剑尖朝上，避免剑包在拖动时触动剑尖导致剑尖失灵。剑身是普通钢材，受潮气容易生锈，一旦剑条生锈容易导致爆线，通常爆线也意味着整支剑报废，所以每次练完应将剑与湿的护面、击剑服分开放置。 花剑重五百克，长一百一十厘米。 花剑比赛也讲究击中优先权。先攻击而击中者得分。被攻击者须先做出有效抵挡动作后再进攻击中才有效。双方同时击中均不得分。在此情况下，击中有先权很难区分，如有时剑触及手臂，在花剑中是无效部位。</p>
                </div>
                }
                {this.props.match.params.id == 3 &&
                <div className="equipment_pic">
                    <img src={require('./../../pic/equipment03.jpg')} alt=""></img>
                    <p>击剑服</p>
                    <p>击剑服对运动员提供安全保护的夹克式外套，长袖，领口覆盖颈部，拉链必须置于持剑手远端一侧，并有面料覆盖，下摆必须遮盖裤子10厘米以上。面料必须可以承受350牛顿的穿透力，在高水平比赛中必须穿着800牛顿以上的击剑服。击剑服是特殊布料制成，练习后击剑服沾汗水最多，如果每次练完将击剑服装在剑包里捂着，并且不经常清洗的话，汗里盐分对衣服有腐蚀性，会使衣料失去韧性，容易被刺穿，这样既不安全也缩短使用时间。击剑服应该每穿5节课后清洗一次，清洗时只需放入洗衣机和普通衣物一起清洗即可。 花剑重五百克，长一百一十厘米。 花剑比赛也讲究击中优先权。先攻击而击中者得分。被攻击者须先做出有效抵挡动作后再进攻击中才有效。双方同时击中均不得分。在此情况下，击中有先权很难区分，如有时剑触及手臂，在花剑中是无效部位。</p>
                </div>
                }
            </main>
        )
    }
};